import { PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '@/_utils/axios';
import { Exception } from '@/redux/slices/slice_types';

export interface ExceptionDrawerState {
  currentException: Exception | null;
  isLoading: boolean;
}

const initialState: ExceptionDrawerState = {
  currentException: null,
  isLoading: false
};

export const getCurrentException = createAsyncThunk('exceptionDrawer/getCurrentException', async (id: Exception['id']) => {
  return axios.get(`/monitoring/events/${id}/`).then((res) => res.data.data);
});

const exceptionDrawerSlice = createSlice({
  name: 'exceptionDrawer',
  initialState,
  reducers: {
    setCurrentException(state, { payload }: PayloadAction<Exception | null>) {
      state.currentException = payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrentException.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCurrentException.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCurrentException.fulfilled, (state, { payload }) => {
      state.currentException = payload;
      state.isLoading = false;
    });
  }
});

export const { setCurrentException } = exceptionDrawerSlice.actions;

export default exceptionDrawerSlice.reducer;
